import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectComponent } from '../select/select.component';
import { NgClass } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-paginacao',
    templateUrl: './paginacao.component.html',
    styleUrls: ['./paginacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectComponent,
        NgClass,
        NgxPaginationModule,
    ],
})
export class PaginacaoComponent {
  @Input() paginacaoId: string;
  @Input() itensPorPaginaId: string;
  @Input() pageSize: any;
  @Input() currentPage: any;
  @Input() totalItems: number;
  @Input() opcoesTamanho = [
    { name: '5 REGISTROS', value: '5' },
    { name: '10 REGISTROS', value: '10' },
    { name: '15 REGISTROS', value: '15' },
    { name: '20 REGISTROS', value: '20' },
  ];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<any>();
}
